import RedirectBanner from './RedirectBanner';

export default RedirectBanner;
